"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
exports.NavbarContainer = styled_components_1.default.nav `
  display: none;
  position: fixed;
  flex-direction: column;
  width: 0;
  height: 100%;
  background: ${props => props.theme.backgrounds.nav};
  overflow: auto;
  
  @media (min-width: 768px) {
    display: block;
    width: ${props => props.theme.sizes.navbar};
  }

  &.nav-open {
    display: block;
    width: ${props => props.theme.sizes.navbar};
  }
`;
exports.NavbarHeader = styled_components_1.default.li `
  margin-bottom: 20px;
  align-items: center;
  justify-content: center;

  padding: 33px 40px;
  float: none;
  position: relative;
  display: block;
`;
exports.NavbarHeaderLogo = styled_components_1.default.img `
  width: 100%;
`;
exports.NavbarMenu = styled_components_1.default.ul `
  list-style: none;
  margin: 0;
  padding: 0;
`;
exports.NavbarMenuItem = styled_components_1.default.li `
  position: relative;
  display: block;
`;
exports.NavbarCloseButton = styled_components_1.default.button `
  display: none;
  position: fixed;
  left: 250px;
  z-index: 9999;

  i {
    color: #fff;
  }

  &.nav-open {
    display: block !important;
  }
`;
exports.Version = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${props => props.theme.colors.gray};
  font-size: 12px;
  padding: 10px;
`;
